import React, { useState } from 'react';
import AnalysisSectionHeader from '/src/Components/AnalysisSectionHeader/AnalysisSectionHeader';
import DataUsed from './DataUsed/DataUsed';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import OurProcess from './OurProcess/OurProcess';
import ProcessConceptIconDark from '/src/assets/process-concept-icon-dark.svg';
import ProcessConceptIconLight from '/src/assets/process-concept-icon-light.svg';
import DatasetIconDark from '/src/assets/dataset-icon-dark.svg';
import DatasetIconLight from '/src/assets/dataset-icon-light.svg';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';
import StandardButton from '/src/Components/StandardButton/StandardButton';
import './style.css';

const Methodology = ({ propertyData }) => {


    const [currentView, setCurrentView] = useState('process');
    const intro_sentence = "Calculating how climate risk impacts your home — both physically and financially — is incredibly complex, requiring highly localized climate data and advanced modeling. Rising insurance premiums, changing property values, and new flood or wildfire maps all reflect how climate change is reshaping homeownership costs.<br/><br/>Click the button below to see how Quoll calculates climate risk for your home and what it means for your financial future."
    const [showProcess, setShowProcess] = useState(false);


    const sections = [
        {
            id: 'process',
            title: 'Process',
            description: 'How we <i>conceptually</i> tackle the problem',
            icon_light: ProcessConceptIconLight,
            icon_dark: ProcessConceptIconDark
        },
        {
            id: 'data',
            title: 'Data We Use',
            description: 'How we <i>pragmatically</i> tackle the problem',
            icon_light: DatasetIconLight,
            icon_dark: DatasetIconDark
        }
    ]

    const showProcessButtonText = "Dive Into the Details"

    const pageTitle = showProcess ? "Assessing a Property" : "How Quoll Calculates Home Climate Risk & Financial Impact"

    return (
        <>
            <HelmetProvider
                pageType="whatWeDo"
            />
            <div className="static-page-content-frame">
                <h1>{pageTitle}</h1>
                {showProcess ? (
                    <OurProcess propertyData={propertyData} />
                ) : (
                    <>
                        <div className="loader-conveyor-belt" />
                            <p className="text-align-center how-we-do-it-intro-text" dangerouslySetInnerHTML={{ __html: intro_sentence }} />
                            
                        <StandardButton
                            onClick={() => setShowProcess(true)}
                            text={showProcessButtonText}
                        />
                        {/* <CTAButton
                            onClick={() => setShowProcess(true)}
                            text={showProcessButtonText}
                        /> */}
                    </>
                )}

                {/* {currentView !== null && <CurlyBraceDivider />}

            {currentView === 'data' && <DataUsed propertyData={propertyData} />}
            {currentView === 'process' && <OurProcess propertyData={propertyData} />} */}
            </div>
        </>
    );
};

export default Methodology;